module.exports = __webpack_public_path__ + "static/img/12-Homes-for-homeless-families-in-Croydon.77ca622e.jpg";